import { Component, OnInit } from '@angular/core';
import { DialogService } from '../dialog.service';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { Device } from '@models';
import { WebClient } from '@injectables';
import { DeviceNode } from '@app/new-ui/flow-board/nodes/device-node/device-node.component';
import { NodeManager } from '@app/utilities/foblex-flow/node-manager';

@Component({
    selector: 'dialog-create-node',
    templateUrl: './dialog-create-node.component.html',
    styleUrls: ['./dialog-create-node.component.scss']
})
export class DialogCreateNodeComponent implements OnInit {
    constructor(
        public readonly dialog: DialogService,
        private readonly fragQuery: FragQueryService,
        private readonly webClient: WebClient,
        private readonly nodeManager: NodeManager
    ) {

    }
    private device: Device
    public readonly devices$ = this.fragQuery.devicesForNodeCreation$;
    public readonly device$ = this.fragQuery.selectedDeviceForNode$;
    public readonly siteId$ = this.fragQuery.siteId$;
    public readonly deviceUuid$ = this.fragQuery.selectedDeviceUuidForNode$;
    public readonly nodeClient = this.webClient.model.node;

    public ngOnInit() {
        this.device$.subscribe(device => {
            this.device = device;
        });
    }

    public async handleAddNode() {
        const deviceNode = new DeviceNode(this.device);
        deviceNode.position = await this.nodeManager.getFreePosition();
        
        const nodeToBeSaved = deviceNode.toNode();
        
        const saved = await this.dialog.await(this.nodeClient.save(nodeToBeSaved));
        if (!saved) {
            this.dialog.notify('Failed to add node');
            return;
        }
        this.fragQuery.trigger$.next();
        
        this.dialog.closeAll()
    }

    public cancel() {
        this.dialog.closeAll();
    }
}
